import Vue from 'vue'
import App from './App.vue'
import router from './router'
import FishUI from 'fish-ui'
import Vuex from 'vuex';
import { Axios_Get,Axios_Post } from "./axios_helper";

import { Form, DatePicker, Space, Collapse, Alert, Switch, BackTop, Spin, Modal, Tabs, Tooltip, Row, Col,Divider, Upload, Popconfirm, Radio, Popover, Checkbox, Progress, Pagination, Button, Drawer, Tag, Menu, Icon, Dropdown, Badge, Table, Input, InputNumber, Select } from 'ant-design-vue';
import 'ant-design-vue/dist/antd.css';

import vueHeadful from 'vue-headful';
import VueApexCharts from 'vue-apexcharts'
Vue.component('apexchart', VueApexCharts)
Vue.component('vue-headful', vueHeadful);
import SKProgress from 'vue-multiple-progress'
Vue.use(SKProgress)
Vue.use(Popconfirm);
Vue.use(Space);
Vue.use(Alert);
Vue.use(BackTop);
Vue.use(Switch);
Vue.use(Divider);
Vue.use(Collapse);
Vue.use(Checkbox);
Vue.use(DatePicker);
Vue.use(Row);
Vue.use(Col);
Vue.use(Tooltip);
Vue.use(Upload);
Vue.use(Modal);
Vue.use(Radio);
Vue.use(Popover);
Vue.use(Form);
Vue.use(Drawer);
Vue.use(Button);
Vue.use(Pagination);
Vue.use(Menu);
Vue.use(Tag);
Vue.use(Tabs);
Vue.use(Input);
Vue.use(InputNumber);
Vue.use(Select);
Vue.use(Table);
Vue.use(Badge);
Vue.use(Dropdown);
Vue.use(Progress);
Vue.use(Icon);
Vue.use(Spin);
Vue.use(Vuex);

import SimpleCaptcha from './components/Captcha.vue'
Vue.component('SimpleCaptcha', SimpleCaptcha) // Đăng ký toàn cục

import FlipCountDown from './components/FlipCountDown.vue'
Vue.component('FlipCountDown', FlipCountDown) // Đăng ký toàn cục

import Scratch_Input from './components/Scratch_Input.vue'
Vue.component('Scratch_Input', Scratch_Input) // Đăng ký toàn cục

import Scratch_Response from './components/Scratch_Response.vue'
Vue.component('Scratch_Response', Scratch_Response) // Đăng ký toàn cục
import Mp4Player from './components/Mp4Player.vue'
Vue.component('Mp4Player', Mp4Player) // Đăng ký toàn cục
const IsDev = localStorage.getItem('PLSTEST') === '1'

Vue.prototype.$IS_DEV = IsDev
Vue.prototype.$PRJ_NAME = 'RCP3'
Vue.prototype.$PRJ_FULLNAME = 'BẬT TIỆC SỐNG ĐỘNG - TRÚNG NGÀN QUÀ CHILL'
Vue.prototype.$START_DATE = '2026-08-08 00:00:00'
Vue.prototype.$END_DATE = '2026-11-21 23:59:59'

Vue.prototype.$POSTER_TYPE = 'CENTER'//BOTTOM_ABSOLUTE,CENTER
Vue.prototype.$PRJ_DOMAIN = 'https://km.biasaigonchill.vn/api'
Vue.prototype.$PRJ_DOMAIN_WS = 'https://km.biasaigonchill.vn/api'
if (Vue.prototype.$IS_DEV==true) {
  // Vue.prototype.$START_DATE = '2026-07-08 00:00:00'
  // Vue.prototype.$PRJ_DOMAIN = 'http://localhost:3000'
  // Vue.prototype.$PRJ_DOMAIN_WS = 'http://localhost:8086'
}
Vue.prototype.$PRJ_LETTER = []
Vue.prototype.$PRJ_SCRATCH_LEN = 8
Vue.prototype.$PRJ_PHONE = '19003375'
Vue.prototype.$PRJ_SMSGW = '6079'
Vue.prototype.$PRJ_ALCOHOL = '4.6%'
Vue.prototype.$SITE_KEY_V3 = '6LcGc9crAAAAAJ8yyK2egtG7aPxlYiixNj-X5JMn'
Vue.prototype.$SITE_KEY_V2 = '6LfA-90rAAAAADzVbK9Dle0uWXxQdIaFBOOhZt0S'


// axios.defaults.baseURL = 'http://sbc2.itcs.com.vn'//'http://sbc2.itcs.com.vn'//
const store = new Vuex.Store({
  state: {
    $message: null,
    oUser: {},
    isLogin: false,
  },
  mutations: {
  },
  getters: {
  },
  actions: {
    Go_Route(path) {
      router.go(path)
    },
    // async AXIOS_POST(context, URL, Data) {
    //   //
    // },
    async API_GetInfo(context, data) {
      let oResponse = await this.AXIOS_GET(Vue.prototype.$PRJ_DOMAIN + '/GetInfo/', data)
      return oResponse
    },
    async API_SearchPhone(context, phone) {
      return await Axios_Get(Vue.prototype.$PRJ_DOMAIN_WS + '/check_phone_web', { checksum: "43c20d08987ce2cbfa761a37e876e2c6", phone: phone })
    },
    async API_SentMO(context, data) {
      return await Axios_Get(Vue.prototype.$PRJ_DOMAIN + '/recvMo', data)
    },
    async API_SentMO_CF(context, data) {
      return await Axios_Post(Vue.prototype.$PRJ_DOMAIN + '/recvMo', data)
    },
    async API_SentMO_V3(context, data) {
      return await Axios_Post(Vue.prototype.$PRJ_DOMAIN + '/recvMo', data)
    },
    async API_SentMO_V2(context, data) {
      return await Axios_Post(Vue.prototype.$PRJ_DOMAIN + '/recvMo2', data)
    },
    async API_SendOTP(context, data) {
      return await Axios_Post(Vue.prototype.$PRJ_DOMAIN + '/SendOTP', data)
    },
    async API_PollingOTP(context, data) {
      return await Axios_Post(Vue.prototype.$PRJ_DOMAIN + '/zenify/dlr/status', data)
    },
    async API_VerifyOTP(context, data) {
      return await Axios_Post(Vue.prototype.$PRJ_DOMAIN + '/VerifyOTP', data)
    },
    async API_ResendOTP(context, data) {
      return await Axios_Post(Vue.prototype.$PRJ_DOMAIN + '/ResendOTP', data)
    },
    async API_SubmitReward(context, data) {
      return await Axios_Post(Vue.prototype.$PRJ_DOMAIN + '/SubmitAward', data)
    },
    async API_GetEntryHistory(context, data) {
      return await Axios_Post(Vue.prototype.$PRJ_DOMAIN + '/GetEntryHistory', data)
    },


  },
  modules: {
  }

});
export default store
import VueNumerals from 'vue-numerals';

import 'animate.css';
Vue.use(require('vue-moment'));
Vue.use(VueNumerals); // default locale is 'en'
Vue.use(FishUI)

Vue.filter('toHHmm', function (value) {
  if (typeof value !== "number") {
    return value;
  }
  return ("0" + Math.floor(value / 60)).slice(-2) + "h" + ("0" + value % 60).slice(-2);
});

Vue.filter('toNumber', function (value) {
  if (typeof value !== "number") {
    return value;
  }
  var formatter = new Intl.NumberFormat('vi-VN', {
    minimumFractionDigits: 0
  });
  return formatter.format(value);
});

Vue.filter('toCurrency', function (value) {
  if (typeof value !== "number") {
    return value;
  }
  var formatter = new Intl.NumberFormat('vi-VN', {
    style: 'currency',
    currency: 'VND',
    minimumFractionDigits: 0
  });
  return formatter.format(value);
});

router.beforeEach((to, from, next) => {
  // if (to.path != "/Login") {
  //   if (localStorage.getItem("isLogin") == "true") {
  //     next()
  //   }
  //   else next("/Login")
  // }
  // else {
  //   if (localStorage.getItem("isLogin") == "true") {
  //     next({ name: "Today", path: "/" })
  //   }
  //   else
  next()
  // }
})
Vue.config.productionTip = false
new Vue({
  router,
  store: store,
  created() {
    // store.commit("Set_Message", this.$message)
    // store.commit("Set_isLogin", localStorage.getItem("isLogin"));
    // console.log(localStorage.getItem("isLogin"))
    // console.log(localStorage.getItem("oUser"))
    // store.commit("Set_oUser", { oUser: JSON.parse(localStorage.getItem("oUser")) });
    // store.dispatch("API_Getinfo")
  },
  methods: {

  },
  // data() {
  //   return {
  //     isLogin: false,
  //   }
  // },
  render: h => h(App),
  actions: {

  }
}).$mount('#app')
